import { render, staticRenderFns } from "./TkHotelAccessInfo.vue?vue&type=template&id=705a3342&"
import script from "./TkHotelAccessInfo.vue?vue&type=script&lang=js&"
export * from "./TkHotelAccessInfo.vue?vue&type=script&lang=js&"
import style0 from "./TkHotelAccessInfo.vue?vue&type=style&index=0&id=705a3342&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports